// @ts-nocheck
import Button from 'views/components/atoms/Button'
import { BUTTON_ON_SUBMIT_ANIMATION_STYLES } from 'views/components/atoms/Button/consts'

const CheckoutButton = ({
  button,
  submitButtonAction,
  disableSubmitButton,
}) => (
  <div className="u-margin--bottom o-CartSumBox__CheckoutButton-container">
    <Button
      id={button.id}
      type="submit"
      name="cart-sumBox-doCheckout-button"
      onClick={submitButtonAction}
      disabled={disableSubmitButton}
      className="o-CartSumBox__CheckoutButton"
      data-submit-styles={
        BUTTON_ON_SUBMIT_ANIMATION_STYLES.rebrandingFilledButton
      }
    >
      {button.label}
    </Button>
  </div>
)

export default CheckoutButton
